/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import { Loader } from 'src/components';
import DocsWrapper from '../../components/DocsWrapper';
import { CandidateDocumentsViewRendererProps } from '../../types';

function Desktop(props: CandidateDocumentsViewRendererProps) {
  const { loading } = props;
  return (
    <>
      <div className="text-left mt-10">
        <DocsWrapper {...props} />
      </div>
      {loading && (
        <div className="fixed top-[50vh] left-[50vw]">
          <Loader />
        </div>
      )}
    </>
  );
}

export default Desktop;
